import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PageRoutes from './routes/PageRoutes';
import { UserProvider } from "./core/providers";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
    return (
        <LanguageProvider>
            <UserProvider>
                <PageRoutes />
            </UserProvider>
        </LanguageProvider>
    );
}

export default App;